import React, { useCallback, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import '@splidejs/react-splide/dist/css/splide-core.min.css'
import useQueryParams from 'utils/hooks/useQueryParams'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'

export default function Billing({ children }) {
  const { query } = useQueryParams()
  const [billingConfig] = useLocalStorage('billing', {})
  const history = useHistory()
  const location = useLocation()
  const pathGen = useGeneratePathI18n()
  const {
    data: { methods: { data: methods = [] } = {} },
    resetData,
    setActiveMethod,
  } = useBilling()

  useEffect(() => () => resetData(), [])

  const methodIndex = useCallback(
    (methodName) => methods.findIndex(({ method }) => method === methodName),
    [methods],
  )

  useEffect(() => {
    if (methods && methods.length) {
      let activeIndex = 0
      if (query.method && methodIndex(query.method) > -1) {
        activeIndex = methodIndex(query.method)
      } else if (billingConfig.method && methodIndex(billingConfig.method) > -1) {
        activeIndex = methodIndex(billingConfig.method)
      }
      setActiveMethod(methods[activeIndex].method)
    }
  }, [methods])

  const handleClose = () => {
    if (location.key && history.length > 1) {
      history.goBack()
    } else {
      history.push(pathGen(ROUTES.SERVICES))
    }
  }

  return React.cloneElement(children, { onClose: handleClose })
}

Billing.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
    PropTypes.oneOf([null]),
  ]),
}
